import { useTranslations } from 'next-intl';

import type { SequenceInstructionFeedbackResultSeverity } from '@/services/httpServices/SequenceServices/types';
import type { IconProps } from '@/types/general';

/**
 * Hook that provides consistent styling and text for instruction feedback across components
 */
export default function useInstructionFeedbackHelper() {
  const translate = useTranslations();

  // Map severity to text colors
  const severityColorMap: Record<SequenceInstructionFeedbackResultSeverity, string> = {
    LOW: 'text-info',
    MEDIUM: 'text-warning',
    HIGH: 'text-error',
  };

  // Map severity to background colors
  const severityBgColorMap: Record<SequenceInstructionFeedbackResultSeverity, string> = {
    LOW: 'bg-info/10',
    MEDIUM: 'bg-warning/10',
    HIGH: 'bg-error/10',
  };

  // Map severity to icons
  const severityIconMap: Record<SequenceInstructionFeedbackResultSeverity, IconProps['icon']> = {
    LOW: 'lucide:info',
    MEDIUM: 'lucide:triangle-alert',
    HIGH: 'lucide:circle-alert',
  };

  // Map severity to translated text
  const severityTextMap: Record<SequenceInstructionFeedbackResultSeverity, string> = {
    LOW: translate('sequence.steps.severity.LOW'),
    MEDIUM: translate('sequence.steps.severity.MEDIUM'),
    HIGH: translate('sequence.steps.severity.HIGH'),
  };

  return {
    severityColorMap,
    severityBgColorMap,
    severityIconMap,
    severityTextMap,
  };
}
